/** V2 Output format from voice-commanding-workflow
 * The final output is IVoiceCommandResultV2
 * This helps in maintaining the order of commands, and allows multiple text annotations
 * Refer this design document for more details: https://microsoft.sharepoint.com/:w:/t/inConcert207/ERU5MsdfFINJrziotHihUL4BsI3newzCoubVo7iWKAmmTA?e=O4Xlqz
*/
/**
 * Enum representing display type of command suggestion
 * Example:
 *  Persistent: "this will be sticky on canvas"
 *  Discardable: “this can be discarded by a user” */
export var CommandSuggestionDisplayType;
(function (CommandSuggestionDisplayType) {
    CommandSuggestionDisplayType["Persistent"] = "Persistent";
    CommandSuggestionDisplayType["Discardable"] = "Discardable";
})(CommandSuggestionDisplayType || (CommandSuggestionDisplayType = {}));
/**
 * Enum representing context type of command suggestion
 * Example:
 * BlankDocument, Paragraph, List, Table etc.*/
export var CommandSuggestionContextType;
(function (CommandSuggestionContextType) {
    CommandSuggestionContextType["NONE"] = "none";
    CommandSuggestionContextType["BLANK"] = "blankDocument";
    CommandSuggestionContextType["PARAGRAPH"] = "paragraph";
    CommandSuggestionContextType["LIST"] = "list";
    CommandSuggestionContextType["TABLE"] = "table";
    CommandSuggestionContextType["WHATCANISAY"] = "whatCanISay";
})(CommandSuggestionContextType || (CommandSuggestionContextType = {}));
/**
 * Enum representing types output from FrontDoor used as input to voice commanding workflow
 * Example:
 *  Final: “This is a test.”
 *  Partial/Hypothesis: “this”, “this is”, “this is a”, “this is a test”
 *  Partial/Fragment: “this”, “is a”, “test”
 * Refer this [design document](https://microsoft.sharepoint.com/:w:/t/MUIPlatform/EQoMo23qQHRBk827sHONmEEBtE9J9lmLvWKux6QDjbl6FQ?e=hnYKqJ) for more details.
 */
export var UtteranceRecognitionType;
(function (UtteranceRecognitionType) {
    UtteranceRecognitionType["Final"] = "Final";
    UtteranceRecognitionType["Fragment"] = "Fragment";
    UtteranceRecognitionType["Hypothesis"] = "Hypothesis";
})(UtteranceRecognitionType || (UtteranceRecognitionType = {}));
/************* Start of - Parameter details ************/
// Note: For SelectionType and SelectionWhich the order means they have higher priority if found in a response
export var SelectionType;
(function (SelectionType) {
    SelectionType["Paragraph"] = "paragraph";
    SelectionType["Sentence"] = "sentence";
    SelectionType["Character"] = "character";
    SelectionType["Word"] = "word";
    SelectionType["That"] = "that";
    SelectionType["This"] = "this";
    SelectionType["Table"] = "table";
    SelectionType["Row"] = "row";
    SelectionType["Column"] = "column";
    SelectionType["Cell"] = "cell";
    SelectionType["Page"] = "page";
    SelectionType["Bullet"] = "bullet";
    SelectionType["To"] = "to";
    SelectionType["Bcc"] = "bcc";
    SelectionType["Cc"] = "cc";
    SelectionType["Subject"] = "subject";
    SelectionType["EmailBody"] = "emailBody";
    SelectionType["Field"] = "field";
    SelectionType["All"] = "all";
})(SelectionType || (SelectionType = {}));
export var SelectionWhich;
(function (SelectionWhich) {
    SelectionWhich["Next"] = "next";
    SelectionWhich["Last"] = "last";
    SelectionWhich["Previous"] = "previous";
    SelectionWhich["Current"] = "current";
    SelectionWhich["Left"] = "left";
    SelectionWhich["Right"] = "right";
    SelectionWhich["Above"] = "above";
    SelectionWhich["Below"] = "below";
    SelectionWhich["Start"] = "start";
    SelectionWhich["End"] = "end";
    // #5181481 - Remove up and down CommandDirection after corresponding AL Changes reaches Prod
    SelectionWhich["Up"] = "up";
    SelectionWhich["Down"] = "down";
    SelectionWhich["Before"] = "before";
    SelectionWhich["After"] = "after";
})(SelectionWhich || (SelectionWhich = {}));
export var AudioMode;
(function (AudioMode) {
    AudioMode["Play"] = "play";
    AudioMode["Pause"] = "pause";
    AudioMode["Resume"] = "resume";
})(AudioMode || (AudioMode = {}));
//# sourceMappingURL=annotations-v2.js.map